import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
const availableClasses = [{
  name: 'A Letter From ADRE',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'Accidental Property Management',
  creditType: '3 hrs. Legal Issues',
  note: null
}, {
  name: 'Are They Represented?',
  creditType: '3 hrs. Agency Law',
  note: null
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: '3 hrs. Contract Law',
  note: null
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'BMC #3B Property Management',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: '3 hrs. General',
  note: null
}, {
  name: "Don't Lose Your License",
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Comm. Standards',
  note: null
}, {
  name: "Fair Housing In Today's World",
  creditType: '3 hrs. Fair Housing',
  note: null
}, {
  name: 'Follow All The Laws',
  creditType: '3 hrs. Legal Issues',
  note: null
}, {
  name: 'Mastering Agency Agreements',
  creditType: '3 hrs. Agency Law',
  note: null
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  note: 'This course is not available with this package.'
}, {
  name: 'No Secrets',
  creditType: '3 hrs. Disclosure',
  note: null
}, {
  name: 'The Bottom Line of Disclosure',
  creditType: '3 hrs. Disclosure',
  note: null
}, {
  name: 'The Owner Is In Default',
  creditType: '3 hrs. Legal Issues',
  note: null
}, {
  name: 'They Are A Protected Class',
  creditType: '3 hrs. Fair Housing',
  note: null
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: '3 hrs. Contract Law',
  note: null
}, {
  name: 'Your Clients Are Not Mushrooms',
  creditType: '3 hrs. Disclosure',
  note: null
}];
export function AvailableClasses() {
  const [selected, setSelected] = useState<Set<number>>(new Set());
  const toggle = (i: number) => {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });
  };
  return <div className="space-y-4" data-id="element-1600">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1601">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1602">
          Available Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1603">
          Select classes to add to your enrollment (My Classes).
        </p>
      </div>

      {/* Info block */}
      <div className="text-sm text-slate-700 space-y-3" data-id="element-1604">
        <p data-id="element-1605">
          You have 0 available classes to choose from.{' '}
          <button className="text-blue-600 hover:underline font-medium" data-id="element-1606">
            Click here to purchase classes &gt;&gt;
          </button>
        </p>

        <p data-id="element-1607">
          <strong data-id="element-1608">Salesperson</strong>
        </p>
        <p data-id="element-1609">
          Your 24 hour requirement (every two years), includes 21 hours (7 class
          types), with at least one class (3 hrs) of each of the following
          credit types:
        </p>

        <ul className="space-y-0.5 pl-1" data-id="element-1610">
          <li data-id="element-1611">• Agency Law</li>
          <li data-id="element-1612">• Contract Law</li>
          <li data-id="element-1613">• Disclosure</li>
          <li data-id="element-1614">• Fair Housing</li>
          <li data-id="element-1615">• General Deed Fraud, Firewise &amp; AZ Water</li>
          <li data-id="element-1616">• Legal Issues</li>
          <li data-id="element-1617">
            • Requirements for Licensees (formerly Commissioner's Standards)
          </li>
          <li data-id="element-1618">
            • Elective credit: 1 class (3 hours){' '}
            <span className="text-slate-500 text-xs" data-id="element-1619">
              You may choose any credit type, providing you do not duplicate any
              course you have already taken within that renewal period
            </span>
          </li>
        </ul>

        <p data-id="element-1620">
          <strong data-id="element-1621">
            Designated, Self-employed Brokers and Associate Brokers with
            Supervisory responsibility are required to take 30 CE credits (every
            2 years) for license renewal (including Broker Management Clinic
            1-3)
          </strong>
        </p>

        <p className="text-slate-600" data-id="element-1622">
          <strong data-id="element-1623">NOTE:</strong> ADRE requires that ALL 3 hr. CE classes, either
          Live or Distance Learning, run for a total of 150 minutes. As required
          by ADRE, all sections in a class is timed. When you begin a section,
          the timer will begin at 25 minutes. As long as your class is open and
          your browser is connected to the server, the timer will continue to
          count down. If you leave the class, your device goes to sleep, click
          on an outside link, or shut off your computer, the timer will stop and
          will begin again where you left off when you log back into the class.
        </p>

        <div data-id="element-1624">
          <button className="px-4 py-2 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#E8A020'
        }} data-id="element-1625">
            CLICK HERE!
          </button>
          <span className="ml-2 text-slate-600" data-id="element-1626">For sample class</span>
        </div>
      </div>

      {/* Table */}
      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1627">
        <div className="overflow-x-auto" data-id="element-1628">
          <table className="w-full text-sm text-left" data-id="element-1629">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-1630">
              <tr data-id="element-1631">
                <th className="px-3 py-3 border-r border-purple-700 w-8" data-id="element-1632"></th>
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-1633">Class</th>
                <th className="px-4 py-3 border-r border-purple-700 w-44" data-id="element-1634">
                  Credit Type
                </th>
                <th className="px-4 py-3 w-24 text-center" data-id="element-1635">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1636">
              {availableClasses.map((cls, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-1637">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1638">
                    <input type="checkbox" checked={selected.has(i)} onChange={() => toggle(i)} className="rounded border-slate-300" disabled={!!cls.note} data-id="element-1639" />
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-1640">
                    <div className="text-slate-800" data-id="element-1641">{cls.name}</div>
                    {cls.note && <div className="text-xs text-slate-500 mt-0.5 italic" data-id="element-1642">
                        {cls.note}
                      </div>}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-700" data-id="element-1643">
                    {cls.creditType}
                  </td>
                  <td className="px-4 py-2.5 text-center text-slate-700" data-id="element-1644"></td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div data-id="element-1645">
        <button className="px-4 py-1.5 text-sm border border-slate-400 bg-slate-100 hover:bg-slate-200 rounded text-slate-800 transition-colors" data-id="element-1646">
          Enroll Me
        </button>
      </div>
    </div>;
}